export const appConstants = {
  ROLES: {
    SUPER: 'SUPER',
    VIEWER: 'VIEWER',
    OWNER: 'OWNER',
  },
  ROUTES: {
    LOGIN: '/login',
    SEARCH_SETUP: '/search-setup',
    SITES_PAGES: '/search-setup/site-pages',
    REGISTRATION: '/registration',
    ORGANIZATION: '/registration/organization',
    SUBSCRIPTION: '/registration/subscription',
    CATEGORY_MANAGER: '/search-setup/site-pages/category-manager',
    CONFIGURE_SEARCH: '/search-setup/configurations',
    TRY_MY_SEARCH: '/search-setup/try-my-search',
    INSTALL_SEARCH: '/install-site-search',
    ADD_CONFIGURATION: '/search-setup/configurations/add-configuration',
    TUTORIAL: '/search-setup/tutorial',
    EDIT_CONFIGURATION: '/search-setup/configurations/edit-configuration',
    WIX_DASHBOARD: '/wix-dashboard',
    WORDPRESS_DASHBOARD: '/wordpress-dashboard',
    SHOPIFY_DASHBOARD: '/shopify-dashboard',
    WIX_PRICING_TABLE: '/wix-pricing-table',
    WIX_POST_PAYMENT: '/wix-post-payment',
  },
  LINKS: {
    WIX_DASHBOARD: 'https://manage.wix.com/dashboard/',
    WIX_GOGOGOGET_APP_NAME: '/search-by-gogo-get',
    WIX_REDIRECT: 'https://wix.to/BWdFj0H',
    WIX_PLUGIN_INSTALLATION_LINK:
      'https://www.wix.com/app-market/search-by-gogo-get',
    WIX_INSTALL_LINK: 'https://www.wix.com/installer/install?token=',
    GOGO_YOUTUBE_LINK_1: 'https://www.youtube.com/embed/Zh9A67wnCc8',
    WORDPRESS_PLUGIN_INSTALLATION_LINK:
      'https://wordpress.org/plugins/search-by-gogo-get/',
  },
  BREADCRUMBS: {
    SEARCH_SETUP: {
      MAIN: 'Search Setup',
      ITEMS: {
        SITES_PAGES: 'My Websites',
        CATEGORY_MANAGER: 'Category Manager',
        ADD_SITE: 'Connect Your Website',
        EDIT_SITE: 'Edit Website Configurations',
        CONFIGURE_SEARCH: 'Search Bar Setup',
        CONFIGURE_NEW_SEARCH: 'Create a Search Bar',
        TRY_MY_SEARCH: 'Test Your Search',
      },
    },
    DASHBOARD: {
      MAIN: 'Dashboard',
      ITEMS: {
        SEARCH_METRICS: 'Search Metrics',
        PLAN_METRICS: 'Plan Metrics',
      },
    },
  },
};
